
import React from 'react';
import TextField from '@mui/material/TextField';

const CommanTextfieldText = ({ label, value, onChange,required,disabled,onBlur,error}) => {
  return (
    <TextField
      fullWidth
      size="small"
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      label={label}     
      helperText={error}
      error={error && error.length ? true : false}
      variant="outlined"       
      disabled={disabled}
      //variant="outlined"   
      required={required}    
    />
  );
};

export default CommanTextfieldText;

